module.exports = __webpack_public_path__ + "img/全部完成.fbcee1af.png";